// extracted by mini-css-extract-plugin
export var measureBox = "_ax-0";